module.exports = __webpack_public_path__ + "static/headshot-057bafa8ba802b0d09e7675cd535e191.jpg";